export const BANNER_TYPES = {
  LINK: "link",
  IMAGE: "image",
};

export const BANNERS = {
  land: {
    type: BANNER_TYPES.LINK,
    imageSource: "https://imgvisilabsnet.azureedge.net/banner/uploaded_images/271_909_20240125110800173.png",
    link: "https://www.youtube.com/watch?v=DYsBJ8GWiko",
    alt: "Arsa Banner",
  },
  october29: {
    type: BANNER_TYPES.IMAGE,
    imageSource: "/assets/images/october29Banner.webp",
    alt: "29 Ekim Cumhuriyet Bayramı",
  },
  november10: {
    type: BANNER_TYPES.IMAGE,
    imageSource: "/assets/images/november10Banner.webp",
    alt: "10 Kasım Atatürk'ü Anma",
  },
};

export const ACTIVE_BANNER = "land";

export const getActiveBanner = () => {
  return ACTIVE_BANNER ? BANNERS[ACTIVE_BANNER] : null;
};
